import React, { useState } from "react";
import Accordion from "components/Accordion";
import PaperCarousel from "components/PaperCarousel";

import useStyles from "./styles";

export interface Props<T> {
  rootRef: React.RefObject<HTMLElement>;
  slides: T[][];
  isFetching: boolean;
  totalCount: number;
  renderSlide: (items) => React.ReactNode;
  title: string | React.ReactElement;
  slideSize: number;
  activeCount?: number;
}

function CollapsibleSlider<T>(props: Props<T>) {
  const {
    rootRef,
    slides,
    isFetching,
    totalCount,
    activeCount,
    renderSlide,
    title,
    slideSize
  } = props;
  const classes = useStyles();
  const [activeSlide, setActiveSlide] = useState<number>(0);

  const handleSlideChange = index => {
    setActiveSlide(index);
  };

  const from = activeSlide * slideSize + 1;
  const to =
    activeSlide * slideSize + slideSize < totalCount
      ? activeSlide * slideSize + slideSize
      : totalCount;

  return (
    <>
      <Accordion
        disabled={(!slides?.length && !isFetching) || isFetching}
        count={activeCount || totalCount}
        showCountLoader
        isLoading={isFetching}
        name={title}
        rootRef={rootRef}
        className={classes.accordion}
        hideBackground
        hideShadow
        roundCount
        hideSubtitleWhenCollapsed
        alert={Boolean(totalCount)}
        subtitle={`Showing ${from}-${to} of ${totalCount}`}
      >
        <PaperCarousel
          items={slides}
          itemRenderer={renderSlide}
          onSlideChange={handleSlideChange}
        />
      </Accordion>
    </>
  );
}

export default CollapsibleSlider;
